import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import CrudReturnReason from '../components/CrudReturnReason';
import i18n from '@/i18n';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['common.tabDetails', 'return.returnReasons'],
    names: ['details', 'returnReasons'],
    header: form => {
      return {
        props: {
          title: form.name || i18n.t('common.finishType')
        }
      };
    },
    groups: [
      {
        name: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'return.returnReasonCategory',
            maxlength: 64,
            required: true
          },
          rules: [{ validator: validatorRequire }]
        },
        categoryNumber: {
          type: MDinput,
          defaultValue: null,
          props: {
            caption: 'return.returnReasonCategoryCode',
            type: 'number',
            maxlength: 2,
            required: true,
            precision: 0
          },
          rules: [{ validator: validatorRequire }]
        },
        returnReasons: {
          type: CrudReturnReason,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'returnReasonCategoryID',
            permissionCode: 'ReturnReason'
          }
        }
      }
    ]
  };
}

const layoutTabVariants = {
  named: true,
  sections: [
    {
      width: 100,
      fields: ['returnReasons']
    }
  ]
};

const layoutTabDetails = {
  named: true,
  sections: [
    {
      width: 100,
      fields: ['name', 'categoryNumber']
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabDetails]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabDetails, layoutTabVariants]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
